import React from 'react';
import PropTypes from 'prop-types';
import { CircleChevronDown } from '../../icon/CircleChevronDown';

function ShowMoreLink({
  label = 'Show more',
  onClick = () => { },
  linkClass = '',
  chevronUp = false,
}) {
  return (
    <div className="link-more-wrap mt-0">
      <a href="#" className={`link-more ${linkClass}`} onClick={(e) => { onClick(); e.preventDefault(); }}>
        <span className={chevronUp ? 'chevron-up' : ''}>
          <CircleChevronDown />
        </span>
        {label}
      </a>
    </div>
  );
}

ShowMoreLink.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  linkClass: PropTypes.string,
  chevronUp: PropTypes.bool,
};

export { ShowMoreLink };
